import { globalAction } from "../actionTypes";

const initialState = {
    theme: 'dark'
};

const globalReducer = (state = initialState, action) => {
    switch (action.type) {
        case globalAction.SET_THEME:
            return { ...state, theme: action.payload };
        default:
            return { ...state };
    }
};

export default globalReducer;
